// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications .otp{
  display: block;
  color: #fff;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  margin: 0 auto;
}

.notifications .otp svg{
  color: #fff;
}

.notification-category{
  max-width: 345px;
  overflow-x: auto;
  padding-bottom: 10px;
}

.notification-category>div{
  min-width: 100px;
}

.green{
  background: #0f5203;
}

.red{
  background: #a10000;
}

.black{
  background: #000;
}

.notify-otp .thumb{
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.notification-content{
  font-size: 14px;
}

.notification-content span{
  display: none;
}

.notification-time{
  color: #bdbdbd;
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-category::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
}

.notification-category::-webkit-scrollbar
{
	height: 3px;
	background-color: #F5F5F5;
}

.notification-category::-webkit-scrollbar-thumb
{
	background-color: #5a5a5a;
}

.notification-title{
  font-weight: 600;
}
/* .unread .notification-title{
  font-weight: 600;
} */
.modal-footer{
  margin: 0 10px;
}

.jumbotron.read{
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Notifications.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;CAEC,iDAAiD;CACjD,yBAAyB;AAC1B;;AAEA;;CAEC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA;;GAEG;AACH;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".notifications .otp{\r\n  display: block;\r\n  color: #fff;\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n  border-radius: 50%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.notifications .otp svg{\r\n  color: #fff;\r\n}\r\n\r\n.notification-category{\r\n  max-width: 345px;\r\n  overflow-x: auto;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.notification-category>div{\r\n  min-width: 100px;\r\n}\r\n\r\n.green{\r\n  background: #0f5203;\r\n}\r\n\r\n.red{\r\n  background: #a10000;\r\n}\r\n\r\n.black{\r\n  background: #000;\r\n}\r\n\r\n.notify-otp .thumb{\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.notification-content{\r\n  font-size: 14px;\r\n}\r\n\r\n.notification-content span{\r\n  display: none;\r\n}\r\n\r\n.notification-time{\r\n  color: #bdbdbd;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.notification-category::-webkit-scrollbar-track\r\n{\r\n\t-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.3);\r\n\tbackground-color: #F5F5F5;\r\n}\r\n\r\n.notification-category::-webkit-scrollbar\r\n{\r\n\theight: 3px;\r\n\tbackground-color: #F5F5F5;\r\n}\r\n\r\n.notification-category::-webkit-scrollbar-thumb\r\n{\r\n\tbackground-color: #5a5a5a;\r\n}\r\n\r\n.notification-title{\r\n  font-weight: 600;\r\n}\r\n/* .unread .notification-title{\r\n  font-weight: 600;\r\n} */\r\n.modal-footer{\r\n  margin: 0 10px;\r\n}\r\n\r\n.jumbotron.read{\r\n  background: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
